import { createContext, useContext } from "react";
import type { ConnectionAlert } from "../types/socialConnections";

/**
 * The connection-health context object on its own, with no imports beyond types:
 * ConnectionHealthContext.tsx (the provider) pulls in the poll and, through it,
 * cognitoService, which builds a CognitoUserPool at module scope. A page that only
 * reads the value (ConnectPage) imports this file instead.
 */
export interface ConnectionHealthValue {
  alerts: ConnectionAlert[];
  redCount: number;
  amberCount: number;
  refetch: () => void;
}

export const ConnectionHealthContext = createContext<ConnectionHealthValue | undefined>(
  undefined
);

/**
 * The value, or undefined outside the provider. For a page that can render
 * without MainLayout (ConnectPage in tests) and only wants to refresh the bell or
 * read an alert when there is one.
 */
export const useOptionalConnectionHealthContext = (): ConnectionHealthValue | undefined =>
  useContext(ConnectionHealthContext);
